import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
	ICustomerFullInfoContext,
	CustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import style from './ActivateBPAField.module.scss';

export const ActivateBPAField: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const { t } = useTranslation('form');
	const isChecked = customerForFullInfo?.isActiveBpa;
	const inputValue = isChecked ? t('yes') : t('no');

	return (
		<FullInfoField
			containerClassName={style.container}
			label="activateBPALabel"
			value={inputValue}
			prefixIcon="asCheckbox"
			prefixIconName={isChecked ? 'checkMark' : 'crossMark'}
			prefixIconIsChecked={isChecked}
		/>
	);
};
